$(document).on('click', '.menu-bars', function(evt){
    $('#menu-list').toggle();
    if ($('.dashboard-link').css('display') == 'none'){
      $('.dashboard-link').css('display', 'block');
      
    }
});